export default __webpack_public_path__ + "static/media/9783986100032.1c80f9ba.webp";